// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-left.js';

import { paths } from '../generated/arrow-left';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-left', Original, paths);
